import clsx from "clsx";
import { User } from "react-feather";
import { InterventionStepBranching } from "src/types/interventions";
import { StepType } from "../../../../types";
import { BranchingHoverCard } from "../../Builders/InterventionBuilder/BranchingHover";
import { UserMessage } from "../UserMessage/UserMessage";

type UserResponseProps = {
  step: InterventionStepBranching;
  opaque?: boolean;
};

export const UserResponse = ({ step, opaque }: UserResponseProps) => {
  const getMessageContent = () => {
    switch (step.type) {
      case StepType.freeText:
        return (
          <UserMessage opaque={opaque}>
            The patient will respond with a free text answer.
          </UserMessage>
        );
      case StepType.thought:
        return <UserMessage opaque={opaque}>The patient will respond with a thought.</UserMessage>;
      case StepType.activity:
        return (
          <UserMessage opaque={opaque}>The patient will respond with an activity.</UserMessage>
        );
      case StepType.emotion:
        return <UserMessage opaque={opaque}>The patient will respond with an emotion.</UserMessage>;
      case StepType.multipleChoice:
        return (
          <div className={"flex flex-wrap items-start justify-end"}>
            {step.configuration.answers.map((answer) => (
              <UserMessage opaque={opaque} key={answer}>
                {answer}
              </UserMessage>
            ))}
          </div>
        );
      case StepType.media:
        return null;

      case StepType.weightedSingleChoice:
      case StepType.singleChoice:
        return (
          <div className={"flex flex-wrap items-start justify-end"}>
            {step.configuration.options.map(({ answer, nextStepOverride, weight }) => (
              <UserMessage
                opaque={opaque}
                key={answer}
                icon={!!nextStepOverride && <BranchingHoverCard />}>
                {answer}
              </UserMessage>
            ))}
          </div>
        );
      default:
        return <UserMessage>{`Unknown step type: ${step.type}`}</UserMessage>;
    }
  };

  return (
    <div className={"flex justify-end"}>
      {getMessageContent()}
      <div
        className={clsx(
          "relative ml-2 mt-1 flex h-[1.75rem] w-[1.75rem] flex-shrink-0 items-center justify-center rounded-full border-[1px] p-0.5 text-gray-500 transition-all duration-standard ease-in-out",
          opaque ? "bg-white/75" : "",
        )}>
        <User />
      </div>
    </div>
  );
};
